module.exports = __webpack_public_path__ + "static/media/PDF_2.8cd9de2e.svg";